<script>
  import DialogSession from '@components/Dialog/Session.vue'
  import File from "@components/List/File";
  import {
    eventTimeRange,
    eventIsStart,
    eventIsEnd,
    eventIsNearStart,
    eventOnlineStatusItem
  } from "@utils/zerone-event";
  import { FAKE_EVENT_ITEM } from "@src/config/fake-evnet";
  import formatDate from "@utils/format-date";
  import { eventSessionButtonStatusItem } from "@utils/zerone-event-status";

  export default {
    components: {
      DialogSession,
      File
    },
    props: {
      eventItem: {
        type: Object,
        default: () => {
          return FAKE_EVENT_ITEM
        },
      },
      type: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        isDialogSessionVisible: false,
        dialogSessionItem: {},
      }
    },
    computed: {
      formattedIsEvent() {
        return this.eventItem.sessions[0].sessions.filter((item) => {
          return !item.isEvent
        })
      }
    },
    methods: {
      eventTimeRange,
      onApply() {
        this.$emit('apply')
      },
      openDialogSession(date, item) {
        this.isDialogSessionVisible = true;
        this.dialogSessionItem = {
          date,
          eventType: this.eventItem.type,
          categoryTitle: this.eventItem.categoryTitle,
          ...item,
        }
      },
      sessionButtonStatusItem(sessionItem) {
        const sessionSessionItem = sessionItem.sessions[1];

        return eventSessionButtonStatusItem({
          ...this.eventItem,
          inProgress: eventIsStart(`${ sessionItem.date } ${ sessionSessionItem.startTime }`) && !eventIsEnd(`${ sessionItem.date } ${ sessionSessionItem.endTime }`),
          canApply: this.eventItem.canApply && sessionSessionItem.canApply,
          canRegistration: sessionSessionItem.canRegistration,
        })
      },
      goToMemberEventItemLive(sessionUuid) {
        this.$router.push({
          name: 'member-event-item-live',
          params: {
            sessionUuid
          }
        })
      },
      eventOnlineStatusItem(sessionsItem) {
        return eventOnlineStatusItem({
          ...this.eventItem,
          ...sessionsItem.sessions[1],
          date: sessionsItem.date,
        })
      },
      sessionIsNearStart(date, time) {
        return eventIsNearStart(`${ date } ${ time }`);
      },
      sessionIsStart(date, time) {
        return eventIsStart(`${ date } ${ time }`);
      },
      sessionIsEnd(date, time) {
        return eventIsEnd(`${ date } ${ time }`);
      },
      onClickOnlineButton(sessionsItem) {
        const mode = this.eventOnlineStatusItem(sessionsItem).mode;
        const sessionsSessionsItem = sessionsItem.sessions[1];

        switch(mode) {
          case 'IS_COMMING':
          case 'IS_LIVE':
          case 'IS_END':
            this.goToMemberEventItemLive(sessionsSessionsItem.uuid);
            break;
          case 'NOT_START':
            this.$alert(`直播開始時間 ${ formatDate(sessionsItem.date + ' ' + sessionsSessionsItem.startTime) }`, '直播尚未開始', {
              confirmButtonText: '確定',
            });
            break;
          case 'NOT_OPEN':
            this.$alert(`直播開放時間 ${ formatDate(sessionsSessionsItem.linkOpeningTime) }`, '直播尚未開放', {
              confirmButtonText: '確定',
            });
            break;
          default:
            break;
        }
      }
    },
  }
</script>
<template>
  <div :class="$style.ArticleContentEvent">
    <div class="ArticleContentEvent__content">
      <h3 class="text-lg-left text-center ArticleContentEvent__sectionTitle">{{eventItem.categoryTitle || '活動'}}簡介</h3>
      <div class="article" v-html="eventItem.introtext"></div>
      <template v-if="eventItem.sessions[0].sessions.length > 1">
        <h3 class="text-lg-left text-center ArticleContentEvent__sectionTitle">{{eventItem.categoryTitle || '活動'}}議程</h3>
        <div class="ArticleContentEvent__timestamp mb-4">
          <!-- <h4 class="ArticleContentEvent__timestamp__title color-gray-6">{{ eventItem.title }}</h4> -->
          <el-table
            class="isStyleTimestamp d-md-block d-none"
            :data="formattedIsEvent"
            :show-header="false"
            stripe
          >
          <el-table-column v-slot="{ row }" label="時間" width="190" class-name="timestamp">
            {{ eventTimeRange({ ...row }) }}
          </el-table-column>
            <el-table-column v-slot="{ row }" label="內容" class-name="content">
              <div class="my-0 text-gray-7">
                {{ row.title }}
              </div>
              <template v-if="!!row.personnels[0]">
                <div
                  v-for="personnelItem in row.personnels"
                  class="mb-0 teacher"
                >
                  {{ personnelItem.title }}：{{ personnelItem.name }}
                </div>
              </template>
            </el-table-column>

            <el-table-column v-slot="{ row }" label="" width="150">
              <template v-if="sessionIsNearStart(eventItem.sessions[0].date, row.startTime) && eventItem.type === 'online'">
                <BaseButton
                  :class="eventOnlineStatusItem(eventItem.sessions[0]).class2"
                  class="isTextUnderline"
                  @click="onClickOnlineButton(eventItem.sessions[0])"
                >
                  {{ eventOnlineStatusItem(eventItem.sessions[0]).title }} >
                </BaseButton>
              </template>
              <template v-else>
                <!--<BaseButton
                  :data-mode="sessionButtonStatusItem(eventItem.sessions[0]).mode"
                  :class="sessionButtonStatusItem(eventItem.sessions[0]).class"
                  class="isTextUnderline"
                  :disabled="sessionButtonStatusItem(eventItem.sessions[0]).disabled"
                  @click="openDialogSession(eventItem.sessions[0].date, row)"
                >
                  {{ sessionButtonStatusItem(eventItem.sessions[0]).title }}
                </BaseButton>-->
                <BaseButton
                  class="isStylePrimary isText readMore"
                  @click="openDialogSession(eventItem.sessions[0].date, row)"
                >
                  查看詳情 >
                </BaseButton>
                <!--<BaseButton
                  class="isStylePrimary isSmall isRadius isOutline2 isFull"
                  @click="openDialogSession(eventItem.sessions[0].date, row)"
                >
                  查看詳情
                </BaseButton>-->
              </template>
            </el-table-column>
          </el-table>
          <!-- 手機版 -->
          <div
            v-for="(item, index) in formattedIsEvent"
            :key="index"
            class="p-4  ArticleContentEvent__mobileEvent d-md-none"
          >
            <div class="row">
              <div class="col-12">
                <div>
                  <!--<span
                    v-if="checkTime(item.timestamp) && fakeState === '活動中'"
                    class="badge rounded-pill isDanger">
                    直播中
                  </span>-->
                  <div class="text-gray-6 d-flex justify-content-between">
                    <span class="text-sm">{{ eventTimeRange({ ...item }) }}</span>
                    <template v-if="sessionIsNearStart(eventItem.sessions[0].date, item.startTime) && eventItem.type === 'online'">
                    <BaseButton
                      :class="eventOnlineStatusItem(eventItem.sessions[0]).class2"
                      class="isTextUnderline"
                      @click="onClickOnlineButton(eventItem.sessions[0])"
                    >
                      {{ eventOnlineStatusItem(eventItem.sessions[0]).title }} >
                    </BaseButton>
                  </template>
                  <BaseButton v-else class="isText text-sm"
                              @click="openDialogSession(eventItem.sessions[0].date, item)">
                    查看詳情 >
                  </BaseButton>
                  </div>
                </div>
                <div>
                  <p class="my-0 text-gray-7 font-medium">
                    {{ item.title }}
                  </p>
                  <template v-if="!!item.personnels[0]">
                    <p
                      v-for="personnelItem in item.personnels"
                      class="mb-0 teacher"
                    >
                      {{ personnelItem.title }}：{{ personnelItem.name }}
                    </p>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <!--<template v-if="fakeState === '開放報名中' ">
        <BaseButton
          class="isStylePrimary isFull ArticleContentEvent__btn isRadius mt-5"
          @click="onApply"
        >
          即刻報名
        </BaseButton>
      </template>
      <template v-else-if="fakeState === '報名截止' || fakeState === '報名額滿'">
        <BaseButton
          class="isStyleGrayLight isFull ArticleContentEvent__btn isRadius mt-5"
          disabled="true"
        >
          {{ fakeState === '報名截止' ? '報名截止' : '已額滿' }}
        </BaseButton>
      </template>-->
      <div v-if="!!eventItem.description" class="section">
        <h3 class="text-lg-left text-center ArticleContentEvent__sectionTitle">{{eventItem.categoryTitle || '活動'}}說明</h3>
        <div class="article" v-html="eventItem.description"></div>
      </div>
      <!-- 講師 -->
      <!--<template v-if=" type === 'live'">
        <h3>講師介紹</h3>
        <div class="row ArticleContentEventteacher__boxInner justify-content-center">
            <div class="col-lg-2 col-4 ArticleContentEvent__teacher__left text-center">
              <div class="ArticleContentEvent__teacher__img">
                <img src="@assets/images/course/man.png" alt="" class="img rounded-circle mb-lg-0 mb-4">
              </div>
            </div>
            <div class="col-lg-10 col-12 ArticleContentEvent__teacher__right">
              <p class="ArticleContentEvent__teacher__name text-lg text-gray-7 font-medium mb-0">
                專業講師 楊斯棓
                <span class="otherIntro text-gray-6 font-regular">| 白日夢國際管理顧問股份有限公司 資深協理</span>
              </p> 
              &lt;!&ndash; <p class="detail__teacher__content" v-html="list.aboutText"></p> &ndash;&gt;
              <p class="ArticleContentEvent__content text-gray-5 text-sm">
                擁有MTPI講師資格認證，教導基、中階主管多年，並擁有多年的管理職經驗，能夠了解主管所面臨的難題，幫助主管做好管理者角色。充分掌握學員特性與主管在面對管理時所遇到的難題，透過邏輯性步驟與實作演練、回饋，協助解決問題。
              </p>
            </div>           
          </div>
      </template>-->
      <div v-if="!!eventItem.files[0]" class="ArticleContentEvent__files section">
        <h3 class="text-lg-left text-center ArticleContentEvent__sectionTitle">{{eventItem.categoryTitle || '活動'}}檔案下載</h3>
        <div v-for="(fileItem, index) in eventItem.files" :key="index" class="mt-3">
          <File
            :item="fileItem"
            icon="<i class='icomoon icon-download'></i>"
          />
        </div>
      </div>
      <div v-if="!!eventItem.sponsors[0]" class="section">
        <h3 class="text-lg-left text-center ArticleContentEvent__sectionTitle">贊助與合作單位</h3>
        <div class="sponsor">
          <div class="row">
            <div v-for="(sponsorItem, index) in eventItem.sponsors" :key="`sponsorItem-${index}`" class="col-sm-4 col-6 text-lg-left text-center">
              <div class="sponsor__item">
                <a
                  :href="sponsorItem.link"
                  target="_blank"
                >
                  <img
                    :src="sponsorItem.logo"
                    :alt="sponsorItem.title"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <DialogSession
      :session-item="dialogSessionItem"
      :visible.sync="isDialogSessionVisible"
    />
  </div>
</template>
<style lang="scss" module>
  .ArticleContentEvent {
    padding-top: 4rem;
    padding-bottom: 3.75rem;
    @include max-lg {
      padding-bottom: 0;
    }
    @include max-md {
      padding-top: 0;
      margin-top: -2rem;
    }
    :global {
      .embed-responsive {
        margin-bottom: 3.75rem;
      }

      .ArticleContentEvent {
        &__timestamp {
          &__title {
            position: relative;
            padding-bottom: 15px;
            text-align: center;

            &::before {
              position: absolute;
              right: 0;
              bottom: 0;
              left: 0;
              width: 100%;
              height: 3px;
              content: '';
              background: $color-primary;
            }
            @include max-md {
              font-size: 1rem;
            }
          }
        }

        &__content {
          line-height: 2;

          .text-small {
            display: block;
            margin-bottom: 2.5rem;
          }

          p {
            margin-bottom: 2.5rem;
            // color: $color-gray-6;
          }

          h3 {
            padding-top: 3rem;
            margin-bottom: 3rem;
            font-size: 1.875rem;
            @include max-md {
              font-size: 1.375rem;
              padding-top: 2.5rem;
            }
          }
        }

        &__btn {
          margin-top: 3.75rem;
          margin-bottom: 3rem;
        }

        &__teacher {
          &__img {
            .img {
              padding: 10px;
              border: 1px solid $color-primary;
            }

          }
        }
        &__mobileEvent {
          border-bottom: 1px solid #E2E4E8;
          &:nth-of-type(odd) {
            background: #F5F5F5;
          }
        }
        &__files {
          @include max-lg {
            background: $color-gray-2;
            padding: 0 $container-gap 2.5rem;
            margin-right: -$container-gap;
            margin-left: -$container-gap;
          }
        }
      }
    }
  }
</style>
